import { App, Row } from "antd";
import { useCallback } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";

export const useConfirmationModal = (
  isLoading: boolean,
  register: (values: any) => Promise<void>,
) => {
  const { modal } = App.useApp();

  const openModal = useCallback(
    (values: any) =>
      modal.confirm({
        centered: true,
        icon: <ExclamationCircleFilled />,
        okText: "Create User",
        okType: "primary",
        okButtonProps: {
          shape: "round",
          disabled: isLoading,
        },
        cancelButtonProps: {
          shape: "round",
          disabled: isLoading,
        },
        className: "confirm-create-admin",
        title: "Maximum Number of Users",
        content: (
          <Row className="d-block">
            <Row className="mb-4">
              <p className="my-0">
                You have reached the maximum number of users. Each additional
                user costs &nbsp;
                <span className="text-md w-500">$50.00/mo</span>.
              </p>
            </Row>
            <Row className="mb-4">
              Create additional user for the additional cost?
            </Row>
            <Row className="mb-4">
              The charge will be added to your next invoice.
            </Row>
          </Row>
        ),
        onOk: async () =>
          await register({ ...values, confirmAdditionalUser: true }),
      }),
    [modal, isLoading, register],
  );

  return { openModal };
};
